// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"237":"529f2c07","239":"b305cede","453":"006a6074","455":"053b410f"}[chunkId] + ".chunk.js";
};